import { render } from "./TableDateWrapper.vue?vue&type=template&id=7891d41e"
import script from "./TableDateWrapper.vue?vue&type=script&lang=js"
export * from "./TableDateWrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__